<template>
  <div>
    <el-upload
        list-type="picture-card"
        :limit="1"
        action=""
        :accept="accept"
        :http-request="getVoucher"
        :on-preview="handlePictureCardPreview"
        :on-remove="removeHandle"
        :file-list="fileList">
      <i class="el-icon-plus"/>
    </el-upload>
    <el-dialog append-to-body :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
  import axios from "axios";
  export default {
    props: {
      authIndex: {
        type: Number,
        required: true,
      },
      imgurl: {
        type: String,
        default: "",
      },
    },

    data() {
      return {
        dialogImageUrl: "",
        dialogVisible: false,
        accept: "image/jpg,image/jpeg,image/png",
        fileList: [],
      };
    },

    watch: {
      imgurl: {
        handler(newVal) {
          if (newVal) {
            let obj = {
              url: newVal,
            };
            this.fileList = [obj];
          }
        },
      },
    },

    methods: {
      // 获取文件上传的url
      getVoucher(file) {
        let type = file.file.name.substring(file.file.name.lastIndexOf(".") + 1);
        if (!["png", "jpg", "jpeg"].includes(type)) {
          this.$confirm("只能上传图片", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        this.$http.get("basic", `files/getUploadUrl?filename=${encodeURIComponent(file.file.name)}&authIndex=${this.authIndex}`).then((res) => {
          if (res.success) {
            axios({
              method: "PUT",
              headers: res.data.headers,
              url: res.data.url,
              data: file.file,
            }).then(() => {
              this.$emit("upload-success", res.data);
            });
          }
        });
      },

      // 图片预览
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },

      removeHandle() {
        this.$emit("removeFile");
      },
    },
  };
</script>
